/** @format */

import * as ActionTypes from "./ActionTypes";

export const editServiceActionPending = () => ({
  type: ActionTypes.EDIT_PROFILE_PENDING,
});

export const editServiceActionError = (error) => ({
  type: ActionTypes.EDIT_PROFILE_ERROR,
  error: error,
});

export const editServiceActionSuccess = (data) => ({
  type: ActionTypes.EDIT_PROFILE_SUCCESS,
  data: data,
});

export const updateServiceActionPending = () => ({
  type: ActionTypes.UPDATE_PROFILE_PENDING,
});

export const updateServiceActionError = (error) => ({
  type: ActionTypes.UPDATE_PROFILE_ERROR,
  error: error,
});

export const updateServiceActionSuccess = () => ({
  type: ActionTypes.UPDATE_PROFILE_SUCCESS,
});

export const onChangeProfileInput = (profileInput) => ({
  type: ActionTypes.ON_CHNAGE_PROFILE_INPUT,
  profileInput,
});
export const profileErrorMessage = (errorMessage) => ({
  type: ActionTypes.PROFILE_ERROR_MESSAGE,
  errorMessage,
});

export const updateProfilePicture = (profileImage) => ({
  type: ActionTypes.UPDATE_PROFILE_PICTURE,
  profileImage,
});
export const updateProfilePictureSuccess = () => ({
  type: ActionTypes.UPDATE_PROFILE_PICTURE_SUCCESS,
});
export const updateProfilePictureError = (error) => ({
  type: ActionTypes.UPDATE_PROFILE_PICTURE_ERROR,
  error,
});
export const toggleEditProfile = () => ({
  type: ActionTypes.TOGGLE_OPEN_EDIT_PROFILE,
});

export const resetProfileData = () => ({
  type: ActionTypes.RESET_PROFILE_DATA,
});

export const updateCustomerPending = () => ({
  type: ActionTypes.UPDATE_CUSTOMER_PENDING,
});

export const updateCustomerSuccess = (data) => ({
  type: ActionTypes.UPDATE_CUSTOMER_SUCCESS,
  data,
});
export const updateCustomerError = () => ({
  type: ActionTypes.UPDATE_CUSTOMER_ERROR,
});
